import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { IPixelCustomDataParameters } from '@faire/web-api--source/indigofair/data/IPixelCustomDataParameters';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'order_submission-first_purchase_placed-click';

/**
 * Send FB Pixel event when user places their first order
 */
export function trackOrderSubmissionFirstPurchasePlacedClick(
  pixelCustomDataParams?: IPixelCustomDataParameters
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    facebookPixelEvent: 'IfFirstPurchase',
    pixelCustomDataParams,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
